import { Map as IMap } from 'immutable';


export const PROCESS_UNSUBSCRIBE = 'unsubscribe/PROCESS_UNSUBSCRIBE';
export const UNSUBSCRIBE_SUCCESS = 'unsubscribe/UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAILURE = 'unsubscribe/UNSUBSCRIBE_FAILURE';


export const UNSUBSCRIBE_STATUS = {
    PENDING: 'pending',
    SUCCESS: 'success',
    FAILURE: 'failure'
};

const initialState = IMap({
    status: null
});

export const processUnsubscribe = ({ token }) => ({
    type: PROCESS_UNSUBSCRIBE,
    payload: { token }
});

export const unsubscribeSuccess = () => ({
    type: UNSUBSCRIBE_SUCCESS
});

export const unsubscribeFailure = () => ({
    type: UNSUBSCRIBE_FAILURE
});

const unsubscribeReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case PROCESS_UNSUBSCRIBE:
            return state.set('status', UNSUBSCRIBE_STATUS.PENDING);
        case UNSUBSCRIBE_SUCCESS:
            return state.set('status', UNSUBSCRIBE_STATUS.SUCCESS);
        case UNSUBSCRIBE_FAILURE:
            return state.set('status', UNSUBSCRIBE_STATUS.FAILURE);
        default:
            return state;
    }
};

export default unsubscribeReducer;
